const style = (theme) => {
  const output = {
    root: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      zIndex: theme.zindex.loader,
      background: theme.colors[1],
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    logo: {
      overflow: 'hidden',
    },
    hide: {
      pointerEvents: 'none',
    },
    firstLine: {
      fill: '#d00000',
    },
    secondLine: {
      fill: '#002450',
    },
  }
  return output
}

export default style
